import { __extends } from "tslib";
import React from "react";
var ComponentBase = /** @class */ (function (_super) {
    __extends(ComponentBase, _super);
    function ComponentBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isFirstRender = true;
        _this.uniqueId = ComponentBase.globalCounter++;
        return _this;
    }
    ComponentBase.prototype.componentDidMount = function () {
        this.afterRender(true);
    };
    ComponentBase.prototype.componentDidUpdate = function () {
        this.afterRender(false);
    };
    /** To be overidden in sub class */
    ComponentBase.prototype.onFirstRender = function () {
    };
    /** To be called by sub class in render method */
    ComponentBase.prototype.onRender = function () {
        if (this.isFirstRender) {
            this.isFirstRender = false;
            this.onFirstRender();
        }
    };
    /** To be overidden in sub class */
    ComponentBase.prototype.afterRender = function (isInitial) {
    };
    ComponentBase.globalCounter = 0;
    return ComponentBase;
}(React.Component));
export default ComponentBase;
